import React from "react";
import { Route, Redirect, Header, isAuthenticate } from "../common";

export default function PrivateRouteWithLayout({
  component: Component,
  ...rest
}) {
  return (
    <>
      <Header />
      <Route
        render={(props) =>
          isAuthenticate() ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: props.location },
              }}
            />
          )
        }
        {...rest}
      />
      {/* {console.log(isAuthenticate())} */}
    </>
  );
}
